import React, { Component } from 'react';
import { message } from 'antd';
import { map } from 'lodash';
import Loader from '../../../Common/Component/Loader';
import {errorHandle} from "../../../Common/errorHandle";

class Customized extends Component {

  state = {
    franchise_uuid: '',
    additional_cleaning_area_price: '',
    add_on: [],
    // roll_of_bags: '',
    loader: false,
    new_franchise: {
      uuid: '',
      city: '',
      state: '',
      name: '',
      accountant_uuid: '',
      manager_uuid: '',
      owner_uuid: '',
      owned_zip_codes: [],
      addressable_zip_codes: [],
      new_cust_not_accept_zip_codes: [],
      aggrement_date: ''
    },
    phone_number: { phone: '' },
    franchise_address: '',
    roll_of_bags: '',
    commercial_roll_bags: '',
    community_card_header_bags: '',
    residential_roll_bags: '',
    residential_roll_bags_provided: false,
    commercial_roll_bags_provided: false,
    community_card_header_bags_provided: false
  }

  componentDidMount = () => {
    if (this.props?.history?.location?.state) {
      this.props.editFieldOffice(this.props?.history?.location?.state.query.data.uuid);
      this.setState({
        loader: true,
        roll_of_bags: this.props?.history?.location?.state.query?.data?.roll_of_bags,
        commercial_roll_bags: this.props?.history?.location?.state.query?.data?.commercial_roll_bags,
        community_card_header_bags: this.props?.history?.location?.state.query?.data?.community_card_header_bags,
        residential_roll_bags: this.props?.history?.location?.state.query?.data?.residential_roll_bags,
      })

    }
  }
  UNSAFE_componentWillReceiveProps = (props) => {
    let { new_franchise } = this.state;
    // message.destroy()
    if (Object.keys(props.EditFieldOffice.data).length > 0 && props.EditFieldOffice.data !== this.props.EditFieldOffice.data) {
      let {
        additional_cleaning_area_price, add_on, roll_of_bags, uuid,
        city, state, phone_number, owned_zip_codes,
        new_cust_not_accept_zip_codes, addressable_zip_codes,
        address, aggrement_date, accountant, manager, owner, name, commercial_roll_bags, community_card_header_bags, residential_roll_bags
        , residential_roll_bags_provided, commercial_roll_bags_provided, community_card_header_bags_provided
      } = props.EditFieldOffice.data;


      console.log("props.EditFieldOffice.data::::", props.EditFieldOffice.data)

      new_franchise =
        Object.assign(new_franchise, {
          name,
          uuid,
          city,
          state,
          owned_zip_codes,
          new_cust_not_accept_zip_codes,
          addressable_zip_codes,
          aggrement_date,
          accountant_uuid: accountant?.uuid,
          manager_uuid: manager?.uuid,
          owner_uuid: owner?.uuid,
        })

      if (this.franchise_address) {
        this.franchise_address.value = address
      }

      this.setState({
        new_franchise,
        phone_number: phone_number ? phone_number : { phone: '' },
        franchise_address: address,
        loader: false,
        franchise_uuid: uuid,
        additional_cleaning_area_price,
        add_on,
        roll_of_bags,
        commercial_roll_bags: Math.floor(commercial_roll_bags),
        community_card_header_bags: Math.floor(community_card_header_bags),
        residential_roll_bags: Math.floor(residential_roll_bags),
        residential_roll_bags_provided,
        commercial_roll_bags_provided,
        community_card_header_bags_provided
      });
    }

    //Update Franchise
    if (Object.keys(props.UpdateFranchise.data).length > 0 && props.UpdateFranchise.data !== this.props.UpdateFranchise.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.UpdateFranchise.errors).length > 0 && props.UpdateFranchise.errors !== this.props.UpdateFranchise.errors) {
      errorHandle(props.UpdateFranchise.errors)
      this.setState({
        loader: false,
      })
    }

    // Update Add on
    if (Object.keys(props.AddonUpdated.data).length > 0 && props.AddonUpdated.data !== this.props.AddonUpdated.data) {

      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.AddonUpdated.errors).length > 0 && props.AddonUpdated.errors !== this.props.AddonUpdated.errors) {
      errorHandle(props.AddonUpdated.errors)
      this.setState({
        loader: false,
      })
    }


  }


  //Add on Text change
  onAddonChange = (e, item) => {
    let { add_on } = this.state;
    let index = add_on.findIndex(x => x.uuid === item.uuid);
    add_on[index]['cost_per_visit'] = e.target.value || 0;
    this.setState({
      add_on
    })

  }

  //Add on Check box check
  onAddOnCheck = (e, item) => {
    let { add_on } = this.state;
    let index = add_on.findIndex(x => x.uuid === item.uuid);
    add_on[index]['is_active'] = e.target.checked;
    this.setState({
      add_on
    })
  }

  //Render Add on
  renderAddon = () => {
    let { add_on } = this.state;
    return map(add_on, (item, i) => {
      return (
        <div className="fitem half-fitem" key={i}>
          <label>{item.name}</label>
          <input
            type="text"
            value={item.cost_per_visit}
            onPaste={(event) => {
              if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                event.preventDefault();
              }
            }}
            onKeyPress={(e) => {
              const pattern = /[0-9]/;
              const inputChar = String.fromCharCode(e.charCode);
              if (!pattern.test(inputChar)
              ) {
                // invalid character, prevent input
                e.preventDefault();
              }
            }}
            placeholder="0"
            onChange={(e) => { this.onAddonChange(e, item) }}
          />
          <div className="inline-check-list gcheck">
            <div className="fitem-check mt-10">
              <input
                type="checkbox"
                className="fitem-ck-input"
                checked={item.is_active}
                id={item.uuid}
                onChange={(e) => { this.onAddOnCheck(e, item) }}
                name="checkboxsa" />
              <label htmlFor={item.uuid} className="fitem-ck-txt">We provide this</label>
            </div>
          </div>
        </div>
      )
    })
  }

  UpdateChanges = () => {
    let { add_on, additional_cleaning_area_price, roll_of_bags, franchise_uuid, new_franchise, franchise_address, phone_number,
      commercial_roll_bags, community_card_header_bags, residential_roll_bags, residential_roll_bags_provided, commercial_roll_bags_provided, community_card_header_bags_provided } = this.state;
    this.setState({
      loader: true
    })
    let data = {
      additional_cleaning_area_price,
      roll_of_bags,
      ...new_franchise,
      address: franchise_address,
      phone_number,
      commercial_roll_bags: commercial_roll_bags_provided ? commercial_roll_bags : 0,

      community_card_header_bags: community_card_header_bags_provided ? community_card_header_bags : 0,

      residential_roll_bags: residential_roll_bags_provided ? residential_roll_bags : 0,

      residential_roll_bags_provided, commercial_roll_bags_provided, community_card_header_bags_provided
    }

    if (!data?.new_cust_not_accept_zip_codes.length > 0) {
      delete data.new_cust_not_accept_zip_codes
    }
    // Update Addon
    map(add_on, x => this.props.updateFieldAddOn(x))
    //Update Franchsie
    this.props.updateFieldOffice(data, franchise_uuid);
  }


  render() {

    let { additional_cleaning_area_price, loader, commercial_roll_bags, community_card_header_bags, residential_roll_bags,
      residential_roll_bags_provided, commercial_roll_bags_provided, community_card_header_bags_provided } = this.state;
    return (
      <div className="customized_wrapper">
        <div className="card">

          <div className="card-body">
            <div className="form-group">
              <h5 className="mb-0"> Additional Areas to Clean</h5>
              <label>Front yard, back yard, right side, left side, dog run, fenced area, other. 1 area included in price.</label>
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <input
                    type="text"
                    name="additional_cleaning_area_price"
                    value={additional_cleaning_area_price}
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)
                      ) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => { this.setState({ additional_cleaning_area_price: e.target.value || 0 }) }}
                  />
                </div>
              </div>
              <h5 className="mb-0 mt-10">Additional Services</h5>
              <div className="fitem half-fitem">
                {this.renderAddon()}
              </div>
              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label>Commercial Roll Bags</label>
                  <input
                    type="text"
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)
                      ) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                    placeholder="0"

                    value={commercial_roll_bags === 0 ? '' : commercial_roll_bags}
                    onChange={(e) => { this.setState({ commercial_roll_bags: e.target.value || 0 }) }}
                  />
                  <div className="fitem-check mt-10">
                    <input type="checkbox"
                      checked={commercial_roll_bags_provided}
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState({
                            commercial_roll_bags_provided: e.target.checked
                          })
                        }
                        else {
                          this.setState({
                            commercial_roll_bags_provided: e.target.checked,
                            commercial_roll_bags: 0
                          })
                        }
                      }}
                      className="fitem-ck-input" id="commercial_roll_bags" name="checkboxsa" />
                    <label htmlFor="commercial_roll_bags" className="fitem-ck-txt">We provide this</label>
                  </div>
                </div>

                <div className="fitem half-fitem">
                  <label>Community Card Header Bags</label>
                  <input
                    type="text"
                    checked={community_card_header_bags}
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)
                      ) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                    placeholder="0"

                    value={community_card_header_bags === 0 ? '' : community_card_header_bags}
                    onChange={(e) => { this.setState({ community_card_header_bags: e.target.value || 0 }) }}
                  />
                  <div className="fitem-check mt-10">
                    <input type="checkbox"
                      checked={community_card_header_bags_provided}
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState({
                            community_card_header_bags_provided: e.target.checked
                          })
                        }
                        else {
                          this.setState({
                            community_card_header_bags_provided: e.target.checked,
                            community_card_header_bags: 0
                          })
                        }
                      }}
                      className="fitem-ck-input" id="community_card_header_bags" name="checkboxsa" />
                    <label htmlFor="community_card_header_bags" className="fitem-ck-txt">We provide this</label>
                  </div>
                </div>

                <div className="fitem half-fitem">
                  <label>Residential Roll Bags</label>
                  <input
                    type="text"
                    onPaste={(event) => {
                      if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                        event.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const pattern = /[0-9]/;
                      const inputChar = String.fromCharCode(e.charCode);
                      if (!pattern.test(inputChar)
                      ) {
                        // invalid character, prevent input
                        e.preventDefault();
                      }
                    }}
                    placeholder="0"
                    value={residential_roll_bags === 0 ? '' : residential_roll_bags}
                    onChange={(e) => { this.setState({ residential_roll_bags: e.target.value }) }}
                  />
                  <div className="fitem-check mt-10">
                    <input type="checkbox"
                      checked={residential_roll_bags_provided}
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState({
                            residential_roll_bags_provided: e.target.checked
                          })
                        }
                        else {
                          this.setState({
                            residential_roll_bags_provided: e.target.checked,
                            residential_roll_bags: 0
                          })
                        }
                      }}
                      className="fitem-ck-input" id="residential_roll_bags" name="checkboxsa" />
                    <label htmlFor="residential_roll_bags" className="fitem-ck-txt">We provide this</label>
                  </div>
                </div>
              </div>

              {/* <h5 className="mb-0 mt-10">Roll of Bags</h5>

              <div className="fitem half-fitem">
                <div className="fitem half-fitem">
                  <label>Single product, cost of a roll of bags</label>
                  <input
                    type="text"
                    name="roll_of_bags"
                    value={roll_of_bags}
                    onChange={(e) => { this.setState({ roll_of_bags: e.target.value }) }}
                  />
                  <div className="fitem-check mt-10">
                    <input type="checkbox" className="fitem-ck-input" id="5" name="checkboxsa" />
                    <label htmlFor="5" className="fitem-ck-txt">We provide this</label>
                  </div>
                </div>
              </div> */}
              <div className={'fitem'} style={{"display": "flex", "justifyContent": "flex-end", "marginTop": "20px"}}>
                <button onClick={() => { this.UpdateChanges(); }} className="btn btn-warning">Save Price Changes</button>
              </div>
            </div>

          </div>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default Customized;